module.exports = __webpack_public_path__ + "static/media/icon_restoration_pontic_2.5791a0a4.svg";